// All values are in PDF points, sized for a reference page (~A4-A5).
// At larger page sizes everything is scaled up uniformly via `scale`.
export const LEGEND_PADDING = 7;
export const LEGEND_ROW_HEIGHT = 14;
export const LEGEND_SWATCH_RADIUS = 4;
export const LEGEND_WIDTH = 240;
export const LEGEND_FONT_SIZE = 10;
export const LEGEND_BORDER_RADIUS = 4;
export const LEGEND_BORDER_WIDTH = 1;
export const LEGEND_PAGE_MARGIN = 20;
// Vertical gap between the separator line below the header and the first row.
export const LEGEND_HEADER_BOTTOM_GAP = 4;
// Horizontal gap between the color swatch and the start of the label text.
export const LEGEND_SWATCH_LABEL_GAP = 6;
// Horizontal gap reserved between the label's right edge and the value column.
export const LEGEND_LABEL_VALUE_GAP = 6;
// X position where the label text starts (scale=1; multiply by scale at render).
export const LEGEND_LABEL_START_X =
  LEGEND_PADDING + LEGEND_SWATCH_RADIUS * 2 + LEGEND_SWATCH_LABEL_GAP;
// X position where the right-aligned value column ends (scale=1).
export const LEGEND_VALUE_END_X = LEGEND_WIDTH - LEGEND_PADDING;

// Page longer-side at which `scale` = 1. Page sides larger than this scale up
// proportionally so the legend stays visible on big plans (A1, A0, custom).
export const LEGEND_REFERENCE_PAGE_SIDE = 800;
// Clamp scale so tiny plans don't shrink the legend below a usable size and
// huge plans don't blow it up to dominate the page.
export const LEGEND_MIN_SCALE = 1;
export const LEGEND_MAX_SCALE = 6;

export const LEGEND_BACKGROUND_FILL = "#FFFFFF";
export const LEGEND_BACKGROUND_OPACITY = 0.92;
export const LEGEND_BORDER_STROKE = "#9CA3AF";
export const LEGEND_TEXT_COLOR = "#111827";
export const LEGEND_FONT_FAMILY = "Helvetica, Arial, sans-serif";
